import script from "./BonusSteps.vue?vue&type=script&setup=true&lang=js"
export * from "./BonusSteps.vue?vue&type=script&setup=true&lang=js"

import "./BonusSteps.vue?vue&type=style&index=0&id=15d64928&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15d64928"]])

export default __exports__